module.exports = __webpack_public_path__ + "img/header_boy.5bc8decc.png";